// ~ REGEXS ~ //

export const regValidateEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

export const regValidatePhone = /^(\+[0-9]{11,13}|[0-9]{9})$/i;

// ~ REGEXS ~ //